import Error from '../shared/error';
import { APIErrorType } from '../../api';
import Loader from '../shared/loader';
import { useParams } from 'react-router-dom';
import { useExamReports } from '../../hooks/react-query/use-exam-report';
import { useExamResults } from '../../hooks/react-query/use-exam-result';
import { useExam } from '../../hooks/react-query/use-exam';
import MainExamReport from './main-exam-report';
import Exam from './exam';
import ExamResults from './exam-results';
import ExamReports from './exam-reports';
import Segment from '../shared/segment';
import ExpireMessageContainer from './expire-message';
import ExamReportDescription from './exam-report-description';

function ExamReportContainer() {
  const { examId } = useParams();
  const {
    isError: examIsError,
    error: examError,
    isLoading: examIsLoading,
    data: exam
  } = useExam(examId ? parseInt(examId) : undefined);
  const {
    isError: examResultsIsError,
    error: examResultsError,
    isLoading: examResultsIsLoading,
    data: examResults
  } = useExamResults(examId ? parseInt(examId) : undefined);
  const {
    isError: examReportsIsError,
    error: examReportsError,
    isLoading: examReportsIsLoading,
    data: examReports
  } = useExamReports(examId ? parseInt(examId) : undefined);

  if (!examId) return <Error />;
  if (examIsError) {
    const error = examError as APIErrorType;
    return <Error error={error} />;
  }
  if (examResultsIsError) {
    const error = examResultsError as APIErrorType;
    return <Error error={error} />;
  }
  if (examReportsIsError) {
    const error = examReportsError as APIErrorType;
    return <Error error={error} />;
  }
  if (
    examReportsIsLoading ||
    !examReports ||
    examIsLoading ||
    !exam ||
    examResultsIsLoading ||
    !examResults
  )
    return <Loader />;

  return (
    <div>
      <Segment bg noMargin className='m-1'>
        <Exam exam={exam} />
        <MainExamReport examReport={examReports[0]} />
        <ExamResults examResults={examResults} />
        {examReports.length > 1 && <ExamReports examReports={examReports.slice(1)} />}
        {exam.expired && !exam.isExpired && <ExpireMessageContainer />}
      </Segment>
      {examReports.length > 1 && (
        <Segment bg noMargin className='m-1'>
          <ExamReportDescription />
        </Segment>
      )}
    </div>
  );
}

export default ExamReportContainer;
